
import ProjectOisItem from '@/components/project/ProjectOisItem'
import FormattedImage from '~/components/common/FormattedImage';
import imagePlaceholder from '~/assets/images/project/stub_card_detail_invest.svg'

export default {
    props: {
        application: {
            type: Object,
            default: null,
        },
    },
    computed: {
        fileId() {
            return this.activeCollateral.contents?.file?.id
        },
        isVideo() {
            return this.activeCollateral.contents.type === 'video';
        },
        poster() {
            return this.activeCollateral.contents.images?.cover_613x345.download_id
                ? this.serverImage(this.activeCollateral.contents.images.cover_613x345.download_id)
                : imagePlaceholder;
        },
        documents() {
            return [...this.activeCollateral.documents, ...this.activeCollateral.contents.documents]
        },
        oisFieldPhonogramTitleName() {
            return this.activeCollateral.contents.type === 'music_phonogram' ? 'фонограммы' : '';
        },
        collateralWorth() {
            return this.activeCollateral.collateral_value ?? this.activeCollateral.estimated_collateral_value;
        },
        collateralWorthSum() {
            let sum = 0;
            this.application.collaterals.forEach((item) => {
                sum += parseFloat(item.collateral_worth);
            });

            return sum;
        }
    },
    created() {
        this.activeCollateral = this.application.collaterals[0];
    },
    data() {
        return {
            activeCollateral: null,
            openedDescription: false,
            paramsRu: {
                manufacturer: 'Изготовитель',
                year_creation: 'Год создания',
                passport_number: 'Номер прокатного удостоверения'
            },
            documentTypes: {
                additional_contract: 'Договор о передаче права на получение вознаграждения',
                deposit_certificate: 'Свидетельство о депонировании',
                contract_lienation: 'Договор отчуждения исключительного права',
                inheritance_certificate: 'Свидетельство о наследстве',
                contract_order_purchase: 'Договора заказа или соглашение о покупке прав для создания контента',
                court_decision: 'Решение суда',
                other_documents: 'Иные документы',
                license_contract: 'Лицензионный договор',
                transfer_agreement: 'Договор о передаче права на получение вознаграждения',
                exclusive_right_regulation_document: 'Сканы отчетов об использовании контента за последние 12 месяцев или с начала действия каждого из договоров (если договором предусмотрены такие отчеты) или иные документы',
                content_usage_report: 'Документы на право получения вознаграждения за использование или распоряжение контентом',
                fee_collection_agreement: 'Документы подтверждающие обладание исключительного права на контент',
                estimate_collateral_value_document: 'Документы по оценочной стоимости',
                collateral_value_document: 'Скан соглашения с другими правообладателями о порядке распоряжения исключительным правом на контент или сканы согласия других правообладателей на передачу в залог исключительного права на контент',
                license_document: 'Лицензионные договора',
            },
            participantTypes: {
                author_music: 'Автор музыки (композитор)',
                performers: 'Исполнители',
                author_text: 'Автор текста',
                executor: 'Исполнители главных ролей',
                author_scenario: 'Авторы сценария',
                producers: 'Режиссер',
            },
            swiperOptions: {
                slidesPerGroup: 5,
                slidesPerView: 5,
                spaceBetween: 25,
                virtual: false,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    1280: {
                        slidesPerGroup: 5,
                        slidesPerView: 5,
                    },
                    1200: {
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                    },
                    800: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                    },
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    }
                }
            },
        }
    },
    methods: {
        toggleDescription() {
            this.openedDescription = !this.openedDescription
        },
        setActiveCollateral(collateral) {
            this.activeCollateral = collateral;
        }
    },
    components: {
        ProjectOisItem,
        FormattedImage
    }
}
